<template>
  <div class="hcl-form-element-radios">
    <template v-if="props.definitionField.field.render === 'grid'">
      <template v-for="(row, index) in mapLookupToRadios" :key="index">
        <hcl-form-input-radios :radios="row" orientation="horizontal" :width="columnWidthRadios"
          :value="props.dataField.value" :disabled="isReadOnly(props.definitionField.field)"
          @hcl-form-input-radios-changed="props.dataField.value = $event.value"
          :widget="props.definitionField.field.widget?.widget" v-bind="generateDataAttributes" />
      </template>
    </template>
    <template v-else>
      <hcl-form-input-radios :radios="mapLookupToRadios"
        :orientation="props.definitionField.field.render === 'inline' ? 'horizontal' : 'vertical'"
        :width="columnWidthRadios" :value="props.dataField.value" :disabled="isReadOnly(props.definitionField.field)"
        @hcl-form-input-radios-changed="props.dataField.value = $event.value"
        :widget="props.definitionField.field.widget?.widget" v-bind="generateDataAttributes" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useElement } from '@/components/FormElement/element'

import HclFormInputRadios from '@/components/FormInputRadios/FormInputRadios.vue'

interface Props {
  definitionField: any
  dataField: any
  dataLookup: any
}

const props = withDefaults(defineProps<Props>(), {
  definitionField: undefined,
  dataField: undefined,
  dataLookup: undefined
})

const { isReadOnly, mapLookupToRadios, columnWidthRadios, generateDataAttributes } = useElement(props)
</script>

<style lang="scss" scoped>
.hcl-form-element-radios {
  width: 100%;
}
</style>
